import { Box, Text } from '@chakra-ui/react';
import { ReactElement } from 'react';

type Props = {
  correctAnswer?: string;
};

export const TextQuestionOrientationAnswer = ({ correctAnswer }: Props): ReactElement | null => {
  if (!correctAnswer?.trim()) {
    return null;
  }

  return (
    <Box
      p="15px"
      borderRadius="l"
      bg="background.canvas"
      border="default"
      borderColor="border.accent"
      width="100%"
    >
      <Text textStyle="body.m.medium" color="text.secondary" display="inline">
        Mögliche Antwort:&nbsp;
      </Text>
      <Text textStyle="body.m.regular" color="text.primary" display="inline" whiteSpace="pre-line">
        {correctAnswer}
      </Text>
    </Box>
  );
};
